import { t } from '@/plugins/i18n'
export const childColumns:any = [
  {
    label: t('THE CKB订单编号'),
    prop: 'platformOrderNo',
    slotName: 'platformOrderNo',
    width: 200
  },
  {
    prop: 'customerOrderNo',
    label: t('THE CKB订单编号'),
    align: 'center',
    width: 200,
    slotHeadName: 'customerOrderNoHead'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    width: 250,
    align: 'center',
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    width: 180,
    align: 'center'
  },
  {
    label: t('客户商品sku'),
    width: 120,
    prop: 'customerProductMsku',
    align: 'center'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    width: 180,
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品状态'),
    align: 'center',
    width: 170,
    slotName: 'shoppingStats'
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('结算状态'),
    prop: 'settleStatus',
    align: 'center',
    slotName: 'settleStatus'
  },
  {
    label: t('商品单价'),
    prop: 'actualProductSellPrice',
    align: 'center',
    slotName: 'actualProductSellPrice'
  },
  {
    label: t('总价'),
    prop: 'actualTotalProductSellPrice',
    align: 'center',
    slotName: 'actualTotalProductSellPrice'
  },
  {
    label: t('业务类型'),
    prop: 'channel',
    align: 'center',
    slotName: 'channel'
  }
]

export const tableConfig = {
  showExpand: true,
  rowKey: 'platformOrderItemId',
  expandConfigId: 'combinationOrderItemList',
  setHeight: true
}

export const childConfig = {
  showExpand: true,
  rowKey: 'platformOrderItemId',
  expandConfigId: 'combinationOrderItemList'
}

// 异常类型
export const abnormalType = {
  /** 2天未发 11 */
  twoNoSend: 11,
  /** 超预计发货时间 12 */
  outTimeSend: 12,
  /** 重点预发跟进 13 */
  mainSend: 13,
  /** 无预计发货时间 14 */
  noSendTime: 14,
  /** 无预计发货时间-转异常 15 */
  noSendTimeAbnormal: 15,
  /** 物流跟进 16 */
  expressFollow: 16,

  /** 超时未到 21 */
  arrivalOutTime: 21,
  /** 预计发货确认 22 */
  confirmTime: 22,
  /** 重点预发跟进 25 */
  mainShipTime: 25,
  /** 无预计发货时间 23 */
  noSendTimeArrival: 23,
  /** 无预计发货时间-转异常 24 */
  noSendTimeAbnormalArrival: 24,

  /** 部分入库 31 */
  partInStock: 31,
  /** 到货异常-超时未到 32 */
  arrivalOutTimeAbnormal: 32,
  /** 到货异常-预计发货确认 33 */
  confirmTimeAbnormal: 33,
  /** 重点预发跟进 34 */
  mainSendAbnormal: 34,
  /** 无预计发货时间 35 */
  noShipTime: 35,
  /** 无预计发货时间-转异常 36 */
  noShipTimeAbnormal: 36

}
// ---------------
// 操作类型
export const handleType = {
  /** 有预计发货时间 1 */
  haveSendTime: 1,
  /** 无预计发货时间 2 */
  noSendTime: 2,
  /** 按预计发货时间正常发货 3 */
  normalShip: 3,
  /** 需持续确认发货时间 4 */
  confirmShipTime: 4,
  /** 等原定时间跟进 5 */
  waitOriginTime: 5
}
// ---------------
// 采购备注
export const purchaseRemark = {
  /** 商品预售 1 */
  productPreSale: 1,
  /** 商家生产中 2 */
  producting: 2,
  /** 商家未回复 3 */
  noReply: 3,
  /** 节假日（工厂放假） 4 */
  factoryHoliday: 4,
  /** 商家预计分批次发货 5 */
  batchesSend: 5,
  /** 需客户确认产品（供应商反馈颜色规格不明确，需确认后才发货，请线下联络测试CS确认） 6 */
  confirmProduct: 6,
  /** 商家出货时间变更，产品还在生产中 7 */
  changeTimeProducting: 7,
  /** 商家可能提前发货 8 */
  advanceShip: 8,
  /** 商家虚假物流 9 */
  fakeExpress: 9,
  /** 包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实） 10 */
  loseExpress: 10
}
/** 物流标签 */
const logisticsTags = {
  /** 无 1 */
  null: 1,
  /** 分包 2 */
  split_pkg: 2,
  /** 商家虚假发货 3 */
  supplier_fake_express: 3,
  /** 物流停滞 4 */
  express_hold: 4,
  /** 物流揽收超时 5 */
  receice_time_out: 5,
  /** 物流周转超时 6 */
  around_time_out: 6,
  /** 节日因素，物流缓慢 7 */
  holidays: 7,
  /** 天气因素，物流缓慢 8 */
  weather: 8,
  /** 运力不足，物流缓慢 9 */
  no_people: 9,
  /** 商家少发 10 */
  supplier_people: 10,
  /** 商家分批次发 11 */
  supplier_split_pkg: 11,
  /** 签收入库中 12 */
  instock_ing: 12,
  /** 包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实） 13 */
  lost_pkg: 13
}

export const logisticsTagsObj = {
  [logisticsTags.null]: t(''),
  [logisticsTags.supplier_fake_express]: t('商家虚假发货'),
  [logisticsTags.around_time_out]: t('物流揽收超时'),
  [logisticsTags.express_hold]: t('物流停滞'),
  [logisticsTags.around_time_out]: t('运力不足，物流缓慢'),
  [logisticsTags.weather]: t('天气因素，物流缓慢'),
  [logisticsTags.holidays]: t('节日因素，物流缓慢'),
  [logisticsTags.split_pkg]: t('分包')

}

/** 跟单记录不同类型下对应的不同枚举 */
export const drawerDocumentaryRecordData = [
  {
    abnormalType: 1,
    name: '超时未发',
    abnormalList: [
      {
        label: '2天未发',
        value: abnormalType.twoNoSend,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商品预售',
                value: purchaseRemark.productPreSale,
                tip: t('商品为预售商品，商家回复预计X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家生产中',
                value: purchaseRemark.producting,
                tip: t('商家还在生产中，商家回复预计X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '节假日（工厂放假）',
                value: purchaseRemark.factoryHoliday,
                tip: t('遇到节假日（工厂放假），商家延迟到X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家预计分批次发货',
                value: purchaseRemark.batchesSend,
                tip: t('商家预计X发货，有可能会分批次发货'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家生产中',
                value: purchaseRemark.producting,
                tip: t('该商品正在生产中，不确认出货时间')
              },
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('询问商家未回复出货时间，会持续跟进')
              },
              {
                label: '需客户确认产品（供应商反馈颜色规格不明确，需确认后才发货，请线下联络测试CS确认）',
                value: purchaseRemark.confirmProduct,
                tip: t('无预计发货时间，正在与您确认商品详细中')
              }
            ]
          }
        ]
      },
      {
        label: '超预计发货时间',
        value: abnormalType.outTimeSend,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,

            list: [
              {
                label: '商品预售',
                value: purchaseRemark.productPreSale,
                tip: t('商品为预售商品，商家回复预计延迟到X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家生产中',
                value: purchaseRemark.producting,
                tip: t('商家还在生产中，商家回复预计延迟到X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '节假日（工厂放假）',
                value: purchaseRemark.factoryHoliday,
                tip: t('遇到节假日（工厂放假），商家回复预计延迟到X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家预计分批次发货',
                value: purchaseRemark.batchesSend,
                tip: t('商家预计延迟到X发货，有可能会分批次发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('商家还在生产中，商家回复预计延迟到X发货'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家生产中',
                value: purchaseRemark.producting,
                tip: t('该商品正在生产中，不确认出货时间')
              },
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('出货时间变更，询问商家未回复出货时间，会持续跟进')
              },
              {
                label: '需客户确认产品（供应商反馈颜色规格不明确，需确认后才发货，请线下联络测试CS确认）',
                value: purchaseRemark.confirmProduct,
                tip: t('出货时间变更，正在与您确认商品详细中')
              }
            ]
          }
        ]
      },
      {
        label: '重点预发跟进',
        value: abnormalType.mainSend,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商品预售',
                value: purchaseRemark.productPreSale,
                tip: t('商品为预售商品，商家回复预计X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '节假日（工厂放假）',
                value: purchaseRemark.factoryHoliday,
                tip: t('遇到节假日（工厂放假），商家延迟到X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家预计分批次发货',
                value: purchaseRemark.batchesSend,
                tip: t('商家预计X发货，有可能会分批次发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('经再次跟卖家确认发货时间，因为产品还在生产中，发货时间延迟至X'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家可能提前发货',
                value: purchaseRemark.advanceShip,
                tip: t('已经再次跟卖家确认发货时间，发货时间提前至X'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '按预计发货时间正常发货',
            value: handleType.normalShip,
            tip: t('已和商家核实是否按原计划发出，发货时间未变'),
            list: []
          },
          {
            label: '需持续确认发货时间',
            value: handleType.confirmShipTime,
            tip: t('已和商家核实是否按原计划发出，卖家暂未回复，明日会继续跟进'),
            list: []
          },
          {
            label: '等原定时间跟进',
            value: handleType.waitOriginTime,
            tip: t('跟卖家确认，卖家扔未回复，卖家除预计发货时间X之外，未给到新的发货信息，若预计发货时间未发货，我司会继续确认'),
            list: []
          }
        ]
      },
      {
        label: '无预计发货时间',
        value: abnormalType.noSendTime,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商品预售',
                value: purchaseRemark.productPreSale,
                tip: t('商品为预售商品，商家回复预计X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家生产中',
                value: purchaseRemark.producting,
                tip: t('商家还在生产中，商家回复预计X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '节假日（工厂放假）',
                value: purchaseRemark.factoryHoliday,
                tip: t('遇到节假日（工厂放假），商家延迟到X'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家预计分批次发货',
                value: purchaseRemark.batchesSend,
                tip: t('商家预计X发货，有可能会分批次发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('商家回复产品还在生产中，预计X发货'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('已跟商家确认最新发货时间，商家未回复')
              },
              {
                label: '需客户确认产品（供应商反馈颜色规格不明确，需确认后才发货，请线下联络测试CS确认）',
                value: purchaseRemark.confirmProduct,
                tip: t('出货时间变更，正在与您确认商品详细中')
              },
              {
                label: '商品预售',
                value: purchaseRemark.productPreSale,
                tip: t('已跟商家确认最新发货时间，商家暂无法提供准确的发货时间')
              },
              {
                label: '商家生产中',
                value: purchaseRemark.producting,
                tip: t('已跟商家确认最新发货时间，商家暂无法提供准确的发货时间')
              },
              {
                label: '节假日（工厂放假）',
                value: purchaseRemark.factoryHoliday,
                tip: t('已跟商家确认最新发货时间，商家暂无法提供准确的发货时间')
              },
              {
                label: '商家预计分批次发货',
                value: purchaseRemark.batchesSend,
                tip: t('已跟商家确认最新发货时间，商家暂无法提供准确的发货时间')
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('已跟商家确认最新发货时间，商家暂无法提供准确的发货时间')
              }
            ]
          }
        ]
      },
      {
        label: '无预计发货时间-转异常',
        value: abnormalType.noSendTimeAbnormal,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商品预售',
                value: purchaseRemark.productPreSale,
                tip: t('商品为预售商品，商家回复预计X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家生产中',
                value: purchaseRemark.producting,
                tip: t('商家还在生产中，商家回复预计X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '节假日（工厂放假）',
                value: purchaseRemark.factoryHoliday,
                tip: t('遇到节假日（工厂放假），商家延迟到X'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家预计分批次发货',
                value: purchaseRemark.batchesSend,
                tip: t('商家会分批发货，首次发货时间为X'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('商家回复产品还在生产中，预计X发货'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('已跟商家确认最新发货时间，商家未回复')
              },
              {
                label: '商品预售',
                value: purchaseRemark.productPreSale,
                tip: t('已跟商家确认最新发货时间，商家暂无法提供准确的发货时间')

              },
              {
                label: '商家生产中',
                value: purchaseRemark.producting,
                tip: t('已跟商家确认最新发货时间，商家暂无法提供准确的发货时间')
              },
              {
                label: '节假日（工厂放假）',
                value: purchaseRemark.factoryHoliday,
                tip: t('已跟商家确认最新发货时间，商家暂无法提供准确的发货时间')
              },
              {
                label: '商家预计分批次发货',
                value: purchaseRemark.batchesSend,
                tip: t('已跟商家确认最新发货时间，商家暂无法提供准确的发货时间')
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('已跟商家确认最新发货时间，商家暂无法提供准确的发货时间')
              },
              {
                label: '需客户确认产品（供应商反馈颜色规格不明确，需确认后才发货，请线下联络测试CS确认）',
                value: purchaseRemark.confirmProduct,
                tip: t('无预计发货时间，正在与您确认商品详细中')
              }
            ]
          }
        ]
      },
      {
        label: '物流跟进',
        value: abnormalType.expressFollow,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商品预售',
                value: purchaseRemark.productPreSale,
                tip: t('商品为预售商品，商家回复预计X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家生产中',
                value: purchaseRemark.producting,
                tip: t('商家还在生产中，商家回复预计X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '节假日（工厂放假）',
                value: purchaseRemark.factoryHoliday,
                tip: t('遇到节假日（工厂放假），商家延迟到X发货'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家预计分批次发货',
                value: purchaseRemark.batchesSend,
                tip: t('商家预计X发货，有可能会分批次发货'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家生产中',
                value: purchaseRemark.producting,
                tip: t('该商品正在生产中，不确认出货时间')
              },
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('已跟商家确认最新发货时间，商家未回复'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '需客户确认产品（供应商反馈颜色规格不明确，需确认后才发货，请线下联络测试CS确认）',
                value: purchaseRemark.confirmProduct,
                tip: t('正在与您确认商品详细中')
              }
            ]
          }
        ]
      }
    ]
  },
  {
    abnormalType: 2,
    name: '超时未到',
    abnormalList: [
      {
        label: '超时未到',
        value: abnormalType.arrivalOutTime,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商家虚假物流',
                value: purchaseRemark.fakeExpress,
                tip: t('确认到最新状态为未发货，原因是之前商家虚假发货，预计最新发货时间为X'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家预计分批次发货',
                value: purchaseRemark.batchesSend,
                tip: t('确认到最新状态为分批次发货，预计剩余商品最新发货时间为X'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实）',
                value: purchaseRemark.loseExpress,
                tip: t('确认到最新状态为未发货，原因包裹丢失，预计最新发货时间为X'),
                time: 'expectedDeliveryTime'
              },
              {
                label: '商家出货时间变更-产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，预计X发货'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家虚假物流',
                value: purchaseRemark.fakeExpress,
                tip: t('确认到最新状态为未发货，原因是之前商家虚假发货，目前暂无预计发货时间，会持续跟进')
              },
              {
                label: '包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实）',
                value: purchaseRemark.loseExpress,
                tip: t('确认到最新状态为未发货，原因包裹丢失，目前暂无预计发货时间，会持续跟进')
              },
              {
                label: '商家出货时间变更-产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，目前暂无预计发货时间，会持续跟进')
              }
            ]
          }
        ]
      },
      {
        label: '超时未到-预计发货确认',
        value: abnormalType.confirmTime,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，预计X发货'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('确认到最新状态为未发货，商家未回复，目前暂无预计发货时间，会持续跟进')
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，目前暂无预计发货时间，会持续跟进')
              }

            ]
          }
        ]
      },
      {
        label: '超时未到-无预计发货时间',
        value: abnormalType.noSendTimeArrival,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，预计X发货'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('确认到最新状态为未发货，商家未回复，目前暂无预计发货时间，会持续跟进')
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，目前暂无预计发货时间，会持续跟进')
              }
            ]
          }
        ]
      },
      {
        label: '超时未到-无预计发货时间-转异常',
        value: abnormalType.noSendTimeAbnormalArrival,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，预计X发货'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('确认到最新状态为未发货，商家未回复，目前暂无预计发货时间，会持续跟进')
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，目前暂无预计发货时间，会持续跟进')
              }
            ]
          }
        ]
      },
      {
        label: '重点跟进',
        value: abnormalType.mainShipTime,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('已为您中途确认，商家生产计划有调整，预计X发货'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，目前暂无预计发货时间，会持续跟进')
              }
            ]
          },
          {
            label: '按预计发货时间正常发货',
            value: handleType.normalShip,
            list: [],
            tip: t('已和商家核实是否按原计划发出，发货时间未变，X'),
            time: 'expectedDeliveryTime'
          },
          {
            label: '需持续确认预计发货时间 （原预计发货时间不变）',
            value: handleType.confirmShipTime,
            list: [],
            tip: t('已和商家核实是否按原计划发出，卖家暂未回复，明日会继续跟进')
          },
          {
            label: '等原定时间跟进',
            value: handleType.waitOriginTime,
            list: [],
            tip: t('已经连续Y次（读取采购确认最近连续次数“需持续确认预计发货时间”）跟卖家确认，卖家扔未回复，卖家除预计发货时间X之外，未给到新的发货信息 若预计发货时间未发货，我司会继续确认'),
            time: 'expectedDeliveryTime'
          }
        ]
      }
    ]
  },
  {
    abnormalType: 3,
    name: '到货异常',
    abnormalList: [
      {
        label: '部分入库',
        value: abnormalType.partInStock,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商家出货时间变更-产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为入库少件，剩余商品预计X到仓（预计到仓时间规则=预计发货时间+3天同现在）'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('确认到最新状态为入库少件，剩余商品，商家未回复，目前暂无预计发货时间，会持续跟进')
              },
              {
                label: '商家出货时间变更-产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为入库少件，剩余商品，商家回复暂无预计发货时间，会持续跟进')
              }
            ]
          }
        ]
      },
      {
        label: '超时未到',
        value: abnormalType.arrivalOutTimeAbnormal,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为入库少件，剩余商品预计X到仓（预计到仓时间规则=预计发货时间+3天同现在）'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('确认到最新状态为入库少件，剩余商品，商家未回复，目前暂无预计发货时间，会持续跟进')
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为入库少件，剩余商品，商家回复暂无预计发货时间，会持续跟进')
              }

            ]
          }
        ]
      },
      {
        label: '预计发货确认',
        value: abnormalType.confirmTimeAbnormal,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为入库少件，剩余商品预计X到仓（预计到仓时间规则=预计发货时间+3天同现在）'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('确认到最新状态为入库少件，剩余商品，商家未回复，目前暂无预计发货时间，会持续跟进')
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为入库少件，剩余商品，商家回复暂无预计发货时间，会持续跟进')
              }
            ]
          }
        ]
      },
      {
        label: '无预计发货时间',
        value: abnormalType.noShipTime,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为入库少件，剩余商品预计X到仓（预计到仓时间规则=预计发货时间+3天同现在）'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('确认到最新状态为入库少件，剩余商品，商家未回复，目前暂无预计发货时间，会持续跟进')
              },
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为入库少件，剩余商品，商家回复暂无预计发货时间，会持续跟进')
              }
            ]
          }
        ]
      },
      {
        label: '无预计发货时间-转异常',
        value: abnormalType.noShipTimeAbnormal,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为入库少件，剩余商品预计X到仓（预计到仓时间规则=预计发货时间+3天同现在）'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家未回复',
                value: purchaseRemark.noReply,
                tip: t('确认到最新状态为入库少件，剩余商品，商家未回复，目前暂无预计发货时间，会持续跟进')
              },
              {
                label: '商家出货时间变更-产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为入库少件，剩余商品，商家回复暂无预计发货时间，会持续跟进')
              }
            ]
          }
        ]
      },
      {
        label: '重点发货跟进',
        value: abnormalType.mainSendAbnormal,
        radioList: [
          {
            label: '有预计发货时间',
            value: handleType.haveSendTime,
            list: [
              {
                label: '商家出货时间变更，产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('已为您中途确认，商家生产计划有调整，预计X发货'),
                time: 'expectedDeliveryTime'
              }
            ]
          },
          {
            label: '无预计发货时间',
            value: handleType.noSendTime,
            list: [
              {
                label: '商家出货时间变更-产品还在生产中',
                value: purchaseRemark.changeTimeProducting,
                tip: t('确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，目前暂无预计发货时间，会持续跟进')
              }
            ]
          },
          {
            label: '按预计发货时间正常发货',
            value: handleType.normalShip,
            list: [],
            tip: t('已和商家核实是否按原计划发出，发货时间未变，X'),
            time: 'expectedDeliveryTime'
          },
          {
            label: '需持续确认预计发货时间 （原预计发货时间不变）',
            value: handleType.confirmShipTime,
            list: [],
            tip: t('已和商家核实是否按原计划发出，卖家暂未回复，明日会继续跟进')
          },
          {
            label: '等原定时间跟进',
            value: handleType.waitOriginTime,
            list: [],
            tip: t('已经连续Y次（读取采购确认最近连续次数“需持续确认预计发货时间”）跟卖家确认，卖家扔未回复，卖家除预计发货时间X之外，未给到新的发货信息 若预计发货时间未发货，我司会继续确认'),
            time: 'expectedDeliveryTime'
          }
        ]
      }
    ]
  }
]

/** 跟单记录不同类型下对应的物流标签 */
export const drawerDocumentaryLogisticsData = [
  {
    abnormalType: 2,
    name: '超时未到',
    abnormalList: [
      {
        label: '超时未到',
        value: abnormalType.arrivalOutTime,
        logisticTagList: [
          {
            label: '商家虚假物流',
            value: logisticsTags.supplier_fake_express,
            tip: t('尚处在中国国内运输中，之前商家提供的物流单号有误，现已更正，预计X到仓'),
            time: 'purchaseEstimateStockTime'

          },
          {
            label: '包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实）',
            value: logisticsTags.lost_pkg,
            tip: t('尚处在中国国内运输中，因运输途中包裹丢失，商家已补发，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '运力不足，物流缓慢',
            value: logisticsTags.no_people,
            tip: t('尚处在中国国内运输中，确认因物流公司运力不足，物流缓慢，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '天气因素，物流缓慢',
            value: logisticsTags.weather,
            tip: t('尚处在中国国内运输中，确认因天气因素，物流缓慢，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '节日因素，物流缓慢',
            value: logisticsTags.holidays,
            tip: t('尚处在中国国内运输中，确认因中国节日因素，物流缓慢，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '签收入库中',
            value: logisticsTags.instock_ing,
            tip: t('包裹已签收，正在紧急入库中')
          }
        ]
      },
      {
        label: '超时未到-预计发货确认',
        value: abnormalType.confirmTime,
        logisticTagList: [
          {
            label: '商家虚假发货',
            value: logisticsTags.supplier_fake_express,
            tip: t('尚处在中国国内运输中，之前商家提供的物流单号有误，现已更正，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实）',
            value: logisticsTags.lost_pkg,
            tip: t('尚处在中国国内运输中，因运输途中包裹丢失，商家已补发，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          }

        ],
        noLogisticTagText: t('确认到最新状态为中国国内运输中，预计X到仓')
      },
      {
        label: '超时未到-无预计发货时间',
        value: abnormalType.noSendTimeArrival,
        logisticTagList: [
          {
            label: '商家虚假发货',
            value: logisticsTags.supplier_fake_express,
            tip: t('尚处在中国国内运输中，之前商家提供的物流单号有误，现已更正，预计X到仓'),
            time: 'purchaseEstimateStockTime'

          },
          {
            label: '包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实）',
            value: logisticsTags.lost_pkg,
            tip: t('尚处在中国国内运输中，因运输途中包裹丢失，商家已补发，预计X到仓'),
            time: 'purchaseEstimateStockTime'

          }
        ],
        noLogisticTagText: t('确认到最新状态为中国国内运输中，预计X到仓')
      },
      {
        label: '超时未到-无预计发货时间-转异常',
        value: abnormalType.noSendTimeAbnormalArrival,
        logisticTagList: [
          {
            label: '商家虚假发货',
            value: logisticsTags.supplier_fake_express,
            tip: t('尚处在中国国内运输中，之前商家提供的物流单号有误，现已更正，预计X到仓'),
            time: 'purchaseEstimateStockTime'

          },
          {
            label: '包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实）',
            value: logisticsTags.lost_pkg,
            tip: t('尚处在中国国内运输中，因运输途中包裹丢失，商家已补发，预计X到仓'),
            time: 'purchaseEstimateStockTime'

          }
        ],
        noLogisticTagText: t('确认到最新状态为中国国内运输中，预计X到仓')
      },
      {
        label: '重点跟进',
        value: abnormalType.mainShipTime,
        logisticTagList: [
          {
            label: '商家虚假发货',
            value: logisticsTags.supplier_fake_express,
            tip: t('尚处在中国国内运输中，之前商家提供的物流单号有误，现已更正，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '商家分批次发',
            value: logisticsTags.supplier_split_pkg,
            tip: t('确认到最新状态为中国国内运输中，商家分批次发，分包物流已新增，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实）',
            value: logisticsTags.lost_pkg,
            tip: t('尚处在中国国内运输中，因运输途中包裹丢失，商家已补发，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '运力不足，物流缓慢',
            value: logisticsTags.no_people,
            tip: t('尚处在中国国内运输中，确认因物流公司运力不足，物流缓慢，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '天气因素，物流缓慢',
            value: logisticsTags.weather,
            tip: t('尚处在中国国内运输中，确认因天气因素，物流缓慢，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '节日因素，物流缓慢',
            value: logisticsTags.holidays,
            tip: t('尚处在中国国内运输中，确认因中国节日因素，物流缓慢，预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '签收入库中',
            value: logisticsTags.instock_ing,
            tip: t('包裹已签收，正在紧急入库中')
          }
        ]
      }
    ]
  },
  {
    abnormalType: 3,
    name: '到货异常',
    abnormalList: [
      {
        label: '部分入库',
        value: abnormalType.partInStock,
        logisticTagList: [
          {
            label: '商家虚假发货',
            value: logisticsTags.supplier_fake_express,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '商家分批次发',
            value: logisticsTags.supplier_split_pkg,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实）',
            value: logisticsTags.lost_pkg,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '运力不足，物流缓慢',
            value: logisticsTags.no_people,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '天气因素，物流缓慢',
            value: logisticsTags.weather,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '节日因素，物流缓慢',
            value: logisticsTags.holidays,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '签收入库中',
            value: logisticsTags.instock_ing,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          }
        ]
      },
      {
        label: '超时未到',
        value: abnormalType.arrivalOutTimeAbnormal,
        logisticTagList: [
          {
            label: '商家虚假发货',
            value: logisticsTags.supplier_fake_express,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '商家分批次发',
            value: logisticsTags.supplier_split_pkg,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实）',
            value: logisticsTags.lost_pkg,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '运力不足，物流缓慢',
            value: logisticsTags.no_people,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '天气因素，物流缓慢',
            value: logisticsTags.weather,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '节日因素，物流缓慢',
            value: logisticsTags.holidays,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '签收入库中',
            value: logisticsTags.instock_ing,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          }
        ]
      },
      {
        label: '预计发货确认',
        value: abnormalType.confirmTimeAbnormal,
        logisticTagList: [
          {
            label: '商家分批次发货',
            value: logisticsTags.supplier_split_pkg,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'

          }
        ],
        noLogisticTagText: t('确认到最新状态为入库少件，剩余商品预计X到仓')
      },
      {
        label: '无预计发货时间',
        value: abnormalType.noShipTime,
        logisticTagList: [
          {
            label: '商家分批次发货',
            value: logisticsTags.supplier_split_pkg,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'

          }
        ],
        noLogisticTagText: t('确认到最新状态为入库少件，剩余商品预计X到仓')
      },
      {
        label: '无预计发货时间-转异常',
        value: abnormalType.noShipTimeAbnormal,
        logisticTagList: [
          {
            label: '商家分批次发货',
            value: logisticsTags.supplier_split_pkg,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'

          }
        ],
        noLogisticTagText: t('确认到最新状态为入库少件，剩余商品预计X到仓')
      },
      {
        label: '重点发货跟进',
        value: abnormalType.mainSendAbnormal,
        logisticTagList: [
          {
            label: '商家虚假发货',
            value: logisticsTags.supplier_fake_express,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '商家分批次发',
            value: logisticsTags.supplier_split_pkg,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '包裹丢失（内部存在仓库/商家/快递核实，对客户宣导快递核实）',
            value: logisticsTags.lost_pkg,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '运力不足，物流缓慢',
            value: logisticsTags.no_people,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '天气因素，物流缓慢',
            value: logisticsTags.weather,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '节日因素，物流缓慢',
            value: logisticsTags.holidays,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          },
          {
            label: '签收入库中',
            value: logisticsTags.instock_ing,
            tip: t('确认到最新状态为入库少件，剩余商品预计X到仓'),
            time: 'purchaseEstimateStockTime'
          }
        ]
      }
    ]
  }
]
